module.exports = __webpack_public_path__ + "static/media/img5.ef49cd7d.png";